export function copyContent(text){
    navigator.clipboard.writeText(text);
}
